var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcBannerArrowRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "b6p1vd7sfa",
    x: 0,
    y: 0,
    width: 66,
    height: 66,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2368"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2384"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#b6p1vd7sfa)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4111",
    d: "M18 0A18 18 0 1 1 0 18 18 18 0 0 1 18 0z",
    transform: "translate(15 14)",
    style: {
      fill: "#fff",
      opacity: 0.805
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 818",
    d: "m12030.038-580.38 7.7-7.126-7.7-7.7",
    transform: "translate(-12000.879 619.513)",
    style: {
      fill: "none",
      stroke: "#666",
      strokeWidth: 3
    }
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcBannerArrowRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-bannerArrowRight.3d00ccccb5a0f265149e85d2620f64f9.svg";